class AssetMetadataStore {
    constructor(rootstore) {
        this._rootstore = rootstore
    }

    async fetchGroups(searchText, language) {
        return this._rootstore
            ._fetch('/assets/search/autocomplete', {
                field: 'metadata',
                language,
                fieldq: searchText,
                'completions.size': 50,
            })
            .then(result => {
                return result['completions']
            })
    }

    async fetchGroupFields(groupName, language) {
        const filterGroupName = groupName + '.'
        return this._rootstore
            ._fetch('/assets/search/autocomplete', {
                field: 'metadata',
                language,
                fieldq: filterGroupName,
            })
            .then(result => {
                return result['completions'].map(fieldName =>
                    fieldName.substring(filterGroupName.length)
                )
            })
    }
}

export default AssetMetadataStore
